import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ContractTypeModel} from './ContractTypeModel';
import {DesignServicesModel} from './DesignServicesModel';
import {ProviderModel} from './ProviderModel';
import {UnitsModel} from './UnitsModel';
import {ServiceVariantModel} from "./ServiceVariantModel";
import {SizeModel} from "./SizeModel";

export class ConsuntivoVolumiModel {
  id: number;
  numAnnoMese: number;
  numAnnoMeseRif: number;
  region: RegionModel;
  localCustomer: LocalCustomerModel;
  contractType: ContractTypeModel;
  resourceUnit: ResourcesUnitModel;
  designServices: DesignServicesModel;
  units: UnitsModel;
  shareName: string;
  applicationDescription: string;
  provider: ProviderModel;
  isRecovery: number;
  serviceVariant: ServiceVariantModel;
  size: SizeModel;
  numAnnoMeseAcceptance: number;
  ulbStatus: string;
  requestId: number;
  requestDesc: string;
  instanceName: string;
  systemName: string;
  monthlyForecastQuantity: number;
  approverRequestor: string;
  notes: string;

  constructor(id?: number,
              numAnnoMeseRif?: number,
              region?: RegionModel,
              localCustomer?: LocalCustomerModel,
              resourceUnit?: ResourcesUnitModel,
              contractType?: ContractTypeModel,
              sl1?: DesignServicesModel,
              units?: UnitsModel,
              shareName?: string,
              applicationDescription?: string,
              provider?: ProviderModel,
              isRecovery?: number,
              serviceVariant?: ServiceVariantModel,
              size?: SizeModel,
              numAnnoMeseAcceptance?: number,
              ulbStatus?: string,
              requestId?: number,
              requestDesc?: string,
              instanceName?: string,
              systemName?: string,
              monthlyForecastQuantity?: number,
              approverRequestor?: string,
              notes?: string) {
    this.id = id;
    this.numAnnoMeseRif = numAnnoMeseRif;
    this.region = region;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.contractType = contractType;
    this.designServices = sl1;
    this.units = units;
    this.shareName = shareName;
    this.applicationDescription = applicationDescription;
    this.provider = provider;
    this.isRecovery = isRecovery;
    this.serviceVariant = serviceVariant;
    this.size = size;
    this.numAnnoMeseAcceptance = numAnnoMeseAcceptance;
    this.ulbStatus = ulbStatus;
    this.requestId = requestId;
    this.requestDesc = requestDesc;
    this.instanceName = instanceName;
    this.systemName = systemName;
    this.monthlyForecastQuantity = monthlyForecastQuantity;
    this.approverRequestor = approverRequestor;
    this.notes = notes;
  }
}
